export default class AccountPageController {
	// Bindings
	icon = '';

	$onInit() {
		// Bindings
		this.icon ??= '';
	}
}
